import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-local-seo',
  templateUrl: './local-seo.component.html',
  styleUrls: ['./local-seo.component.css'],
})
export class LocalSeoComponent {
  url: string = 'seoOffpageCampaigns';

  loading: boolean = true;
  saving: boolean = false;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  // ── Filter state ──────────────────────────────────────────────────────────
  selectedMarketStatus: string = 'all';
  selectedUniverse: string = 'all';
  selectedLocation: string = 'all';
  selectedService: string = 'all';
  selectedIssueType: string = '';
  selectedStatus: string = '';

  pendingMarketStatus: string = 'all';
  pendingUniverse: string = 'all';
  pendingLocation: string = 'all';
  pendingService: string = 'all';
  pendingIssueType: string = '';
  pendingStatus: string = '';

  activeTab: string = 'all';

  // ── Lookup tables ─────────────────────────────────────────────────────────
  marketStatuses = [
    { value: 'all', label: 'All Markets' },
    { value: 'active', label: 'Active' },
    { value: 'growth', label: 'Growth' },
    { value: 'expansion', label: 'Expansion' },
    { value: 'not_active', label: 'Not Active' },
  ];

  universes = [
    { value: 'all', label: 'All Universes' },
    { value: 'courier', label: 'Courier' },
    { value: 'runner', label: 'Runner' },
  ];

  locations = [
    { value: 'all', label: 'All Locations' },
    { value: 'miami_fl', label: 'Miami, FL' },
    { value: 'fort_lauderdale_fl', label: 'Fort Lauderdale, FL' },
    { value: 'west_palm_beach_fl', label: 'West Palm Beach, FL' },
    { value: 'orlando_fl', label: 'Orlando, FL' },
    { value: 'tampa_fl', label: 'Tampa, FL' },
    { value: 'aventura_fl', label: 'Aventura, FL' },
    { value: 'boca_raton_fl', label: 'Boca Raton, FL' },
  ];

  services = [
    { value: 'all', label: 'All Services' },
    { value: 'same_day_courier', label: 'Same-Day Courier' },
    { value: 'rush_courier', label: 'Rush Courier' },
    { value: 'concierge_services', label: 'Concierge Services' },
  ];

  issueTypes = [
    { value: '', label: 'All Issues' },
    { value: 'gbp_incomplete', label: 'GBP Incomplete' },
    { value: 'missing_citation', label: 'Missing Citation' },
    { value: 'low_review_velocity', label: 'Low Review Velocity' },
    { value: 'local_pack_weakness', label: 'Local Pack Weakness' },
    { value: 'nap_inconsistency', label: 'NAP Inconsistency' },
    { value: 'service_area_gap', label: 'Service Area Gap' },
    { value: 'duplicate_listing', label: 'Duplicate Listing' },
    { value: 'unanswered_reviews', label: 'Unanswered Reviews' },
  ];

  statuses = [
    { value: '', label: 'All Statuses' },
    { value: 'needs_attention', label: 'Needs Attention' },
    { value: 'needs_fix', label: 'Needs Fix' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'resolved', label: 'Resolved' },
  ];

  // ── Tabs ──────────────────────────────────────────────────────────────────
  tabs = [
    { key: 'all', label: 'All Issues', count: 58, colorClass: 'text-dark' },
    {
      key: 'critical',
      label: 'Critical',
      count: 12,
      colorClass: 'text-danger',
    },
    { key: 'gbp', label: 'GBP', count: 15, colorClass: 'text-success' },
    {
      key: 'citations',
      label: 'Citations',
      count: 16,
      colorClass: 'text-warning',
    },
    { key: 'reviews', label: 'Reviews', count: 9, colorClass: 'text-purple' },
    {
      key: 'visibility',
      label: 'Visibility',
      count: 10,
      colorClass: 'text-info',
    },
    { key: 'nap', label: 'NAP', count: 6, colorClass: 'text-danger' },
    {
      key: 'local_pages',
      label: 'Local Pages',
      count: 6,
      colorClass: 'text-primary',
    },
    {
      key: 'service_areas',
      label: 'Service Areas',
      count: 4,
      colorClass: 'text-info',
    },
  ];

  // ── Loaded campaigns data (fallback if api succeeds) ──────────────────────
  allCampaigns: any[] = [];
  campaign: any = null;
  campaignId: string = '';

  // ── Stats ─────────────────────────────────────────────────────────────────
  stats = {
    activeMarkets: { value: 0, trend: '', up: true },
    gbpHealthScore: { value: 0, trend: '', up: true },
    citationConsistency: { value: 0, trend: '', up: true },
    averageRating: { value: 0, trend: '', up: true },
    localPackVisibility: { value: 0, trend: '', up: false },
    criticalIssues: { value: 0, trend: '', up: false },
  };

  // ── Issues Queue (main table) ─────────────────────────────────────────────
  issuesQueue: any[] = [];

  // ── Selected issue for right panel & action center ────────────────────────
  selectedIssue: any = {
    location: '',
    locationKey: '',
    issueType: '',
    issueDetails: '',
    impact: 'Medium',
    status: 'Needs Attention',
    detected: '',
    recommendedAction: '',
    category: '',
    primaryService: '',
    marketPriority: '',
    activeMarket: true,
    keyMetrics: {
      gbpHealth: '',
      citationConsistency: '',
      averageRating: 0.0,
      totalReviews: 0,
      localPackVisibility: '',
      visibilityTrend: '',
      visibilityTrendUp: false,
      reviewVelocity: '',
      napStatus: '',
      serviceArea: '',
    },
    topIssue: {
      title: '',
      description: '',
      totalIssues: 0,
    },
    actionCenter: {
      selectedAction: '',
      targetLocation: '',
      element: '',
      decisionOrigin: '',
      currentText: '',
      proposedText: '',
      aiRecommendation: '',
      aiConfidence: 0,
      riskLevel: '',
      executionMode: '',
    },
    _index: -1,
  };

  // ── Market Overview ──────────────────────────────────────────────────────
  marketOverview = {
    score: 6,
    active: { count: 6, pct: 50 },
    growth: { count: 3, pct: 25 },
    expansion: { count: 3, pct: 25 },
    notActive: { count: 0, pct: 0 },
  };

  // ── Bottom Section lists ──────────────────────────────────────────────────
  localPackVisibilityList = [
    { name: 'Miami, FL', pct: 82, color: '#28a745' },
    { name: 'Fort Lauderdale, FL', pct: 74, color: '#28a745' },
    { name: 'West Palm Beach, FL', pct: 61, color: '#fd7e14' },
    { name: 'Orlando, FL', pct: 38, color: '#dc3545' },
    { name: 'Tampa, FL', pct: 32, color: '#dc3545' },
  ];

  averageRatingsList = [
    { name: 'Miami, FL', rating: 4.7 },
    { name: 'Fort Lauderdale, FL', rating: 4.5 },
    { name: 'West Palm Beach, FL', rating: 4.6 },
    { name: 'Orlando, FL', rating: 4.2 },
    { name: 'Tampa, FL', rating: 4.1 },
  ];

  reviewsOverTime = {
    totalReviews: 142,
    trend: '12 vs last 30 days',
    up: true,
  };

  citationConsistencyList = [
    { name: 'Miami, FL', pct: 87 },
    { name: 'Fort Lauderdale, FL', pct: 86 },
    { name: 'West Palm Beach, FL', pct: 81 },
    { name: 'Orlando, FL', pct: 73 },
    { name: 'Tampa, FL', pct: 71 },
  ];

  signals: any[] = [];
  recentLocalActivity: any[] = [];

  constructor(
    private router: Router,
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  // ── Lifecycle ─────────────────────────────────────────────────────────────
  ngOnInit(): void {
    this.loadCampaigns();
  }

  // ── Data loading ──────────────────────────────────────────────────────────
  loadCampaigns(): void {
    this.loading = true;
    const params = `?status=approved&limit=200`;

    this.dataService.getData(`${this.url}${params}`).subscribe(
      (response: any) => {
        if (response.rst && response.data) {
          this.allCampaigns = response.data;
          this.applyFilterAndSelect();
        } else {
          this.messageService.add(
            response.msg || 'Error loading campaigns',
            'danger',
          );
          this.loading = false;
          this.buildStaticData();
        }
      },
      (_err: any) => {
        this.messageService.add('Could not connect to the server.', 'danger');
        this.loading = false;
        this.buildStaticData();
      },
    );
  }

  applyFilterAndSelect(): void {
    const matched = this.allCampaigns.filter((c: any) => {
      const locMatch =
        this.selectedLocation === 'all' ||
        !this.selectedLocation ||
        c.location === this.selectedLocation;
      const uniMatch =
        this.selectedUniverse === 'all' ||
        !this.selectedUniverse ||
        c.universe === this.selectedUniverse;
      const serviceMatch =
        this.selectedService === 'all' ||
        !this.selectedService ||
        c.service === this.selectedService;
      return locMatch && uniMatch && serviceMatch;
    });

    if (matched.length > 0) {
      this.campaign = matched[0];
      this.campaignId = matched[0]._id;
    }

    this.buildStaticData();
    this.loading = false;
  }

  onFilterChange(): void {
    this.selectedMarketStatus = this.pendingMarketStatus;
    this.selectedUniverse = this.pendingUniverse;
    this.selectedLocation = this.pendingLocation;
    this.selectedService = this.pendingService;
    this.selectedIssueType = this.pendingIssueType;
    this.selectedStatus = this.pendingStatus;

    this.applyFilterAndSelect();
  }

  // ── Build static / demo data ──────────────────────────────────────────────
  buildStaticData(): void {
    this.buildStats();
    this.buildIssuesQueue();
    this.buildSignals();
    this.buildRecentLocalActivity();
    if (this.issuesQueue.length > 0) {
      this.selectIssue(this.issuesQueue[0]);
    }
  }

  buildStats(): void {
    this.stats = {
      activeMarkets: { value: 6, trend: '1 vs last 30 days', up: true },
      gbpHealthScore: { value: 87, trend: '6% vs last 30 days', up: true },
      citationConsistency: { value: 82, trend: '5% vs last 30 days', up: true },
      averageRating: { value: 4.6, trend: '0.2 vs last 30 days', up: true },
      localPackVisibility: {
        value: 68,
        trend: '3% vs last 30 days',
        up: false,
      },
      criticalIssues: { value: 12, trend: '2 vs last 30 days', up: false },
    };
  }

  buildIssuesQueue(): void {
    this.issuesQueue = [
      {
        location: 'Miami, FL',
        locationKey: 'miami_fl',
        issueType: 'GBP Incomplete',
        issueDetails: 'Business description too short',
        impact: 'Medium',
        status: 'Needs Attention',
        detected: 'May 18, 2025',
        recommendedAction: 'Expand Description',
        category: 'gbp',
        primaryService: 'Same-Day Courier',
        marketPriority: 'Core Market',
        activeMarket: true,
        keyMetrics: {
          gbpHealth: 'Good (85%)',
          citationConsistency: 'Good (87%)',
          averageRating: 4.7,
          totalReviews: 142,
          localPackVisibility: 'Medium (62%)',
          visibilityTrend: '4%',
          visibilityTrendUp: false,
          reviewVelocity: '3 new reviews',
          napStatus: 'Inconsistent',
          serviceArea: 'Miami-Dade County',
        },
        topIssue: {
          title: 'GBP Incomplete',
          description:
            'Business description is too short and does not clearly communicate value and services.',
          totalIssues: 8,
        },
        actionCenter: {
          selectedAction: 'Expand GBP Description',
          targetLocation: 'Miami, FL',
          element: 'GBP Business Description',
          decisionOrigin: 'AI Detected',
          currentText:
            'We provide same-day courier and concierge services in Miami and surrounding areas.',
          proposedText:
            'Courier & Beyond provides same-day courier, rush, and concierge services in Miami and throughout Miami-Dade County. We deliver what matters, when it matters.',
          aiRecommendation:
            'The current description is too short and does not highlight services, coverage or value. The proposed version improves relevance and can help local visibility.',
          aiConfidence: 91,
          riskLevel: 'High',
          executionMode: 'Human Approval Required',
        },
      },
      {
        location: 'Fort Lauderdale, FL',
        locationKey: 'fort_lauderdale_fl',
        issueType: 'Missing Citation',
        issueDetails: 'Missing in Yelp',
        impact: 'High',
        status: 'Needs Fix',
        detected: 'May 18, 2025',
        recommendedAction: 'Create Citation',
        category: 'citations',
        primaryService: 'Rush Courier',
        marketPriority: 'Growth Market',
        activeMarket: true,
        keyMetrics: {
          gbpHealth: 'Good (87%)',
          citationConsistency: 'Good (86%)',
          averageRating: 4.5,
          totalReviews: 96,
          localPackVisibility: 'Low (48%)',
          visibilityTrend: '2%',
          visibilityTrendUp: false,
          reviewVelocity: '1 new review',
          napStatus: 'Consistent',
          serviceArea: 'Broward County',
        },
        topIssue: {
          title: 'Missing Citation',
          description:
            'No active profile found on Yelp. Citation signal is missing.',
          totalIssues: 5,
        },
        actionCenter: {
          selectedAction: 'Create Yelp Citation',
          targetLocation: 'Fort Lauderdale, FL',
          element: 'Yelp Business Profile',
          decisionOrigin: 'System Detected',
          currentText: 'Profile status: Unregistered.',
          proposedText:
            'Create verified Yelp listing: Courier & Beyond - Fort Lauderdale, FL. Address: 104 Los Olas Blvd.',
          aiRecommendation:
            'Yelp presence is required to fix the local citation gap. The proposed action creates a listing with verified data.',
          aiConfidence: 95,
          riskLevel: 'Low',
          executionMode: 'Human Approval Required',
        },
      },
      {
        location: 'West Palm Beach, FL',
        locationKey: 'west_palm_beach_fl',
        issueType: 'Low Review Velocity',
        issueDetails: 'No new reviews in last 45 days',
        impact: 'Medium',
        status: 'Needs Attention',
        detected: 'May 17, 2025',
        recommendedAction: 'Launch Review Initiative',
        category: 'reviews',
        primaryService: 'Concierge Services',
        marketPriority: 'Growth Market',
        activeMarket: true,
        keyMetrics: {
          gbpHealth: 'Good (83%)',
          citationConsistency: 'Good (84%)',
          averageRating: 4.6,
          totalReviews: 78,
          localPackVisibility: 'Medium (55%)',
          visibilityTrend: '1%',
          visibilityTrendUp: true,
          reviewVelocity: '0 new reviews (45d)',
          napStatus: 'Consistent',
          serviceArea: 'Palm Beach County',
        },
        topIssue: {
          title: 'Low Review Velocity',
          description:
            'No new customer reviews received in the last 45 days, causing ranking stagnation.',
          totalIssues: 3,
        },
        actionCenter: {
          selectedAction: 'Launch Review Campaign',
          targetLocation: 'West Palm Beach, FL',
          element: 'Review Acquisition Campaign',
          decisionOrigin: 'User Triggers',
          currentText: 'Review request automation: Disabled.',
          proposedText:
            'Enable SMS & Email request automation for recent West Palm Beach deliveries.',
          aiRecommendation:
            'Automating requests can increase review volume and velocity, signaling active local operations to search engines.',
          aiConfidence: 89,
          riskLevel: 'Low',
          executionMode: 'Automatic Execution',
        },
      },
      {
        location: 'Orlando, FL',
        locationKey: 'orlando_fl',
        issueType: 'Local Pack Weakness',
        issueDetails: 'Not appearing in top 3 for target keywords',
        impact: 'High',
        status: 'Under Review',
        detected: 'May 17, 2025',
        recommendedAction: 'Review Local Signals',
        category: 'visibility',
        primaryService: 'Same-Day Courier',
        marketPriority: 'Core Market',
        activeMarket: true,
        keyMetrics: {
          gbpHealth: 'Good (80%)',
          citationConsistency: 'Fair (72%)',
          averageRating: 4.2,
          totalReviews: 110,
          localPackVisibility: 'Low (38%)',
          visibilityTrend: '5%',
          visibilityTrendUp: false,
          reviewVelocity: '4 new reviews / mo',
          napStatus: 'Consistent',
          serviceArea: 'Orange County',
        },
        topIssue: {
          title: 'Local Pack Weakness',
          description:
            'Business does not rank in the local top-3 map pack for core queries.',
          totalIssues: 12,
        },
        actionCenter: {
          selectedAction: 'Review Local Signals',
          targetLocation: 'Orlando, FL',
          element: 'Ranking Weakness',
          decisionOrigin: 'AI Analysis',
          currentText: 'Local category ranking: #6 average.',
          proposedText:
            'Identify and resolve local signal gaps, including secondary categories and internal links.',
          aiRecommendation:
            'GBP optimization is needed. Adding secondary categories like "Delivery Service" can help bridge search intent.',
          aiConfidence: 94,
          riskLevel: 'Medium',
          executionMode: 'Manual Analysis',
        },
      },
      {
        location: 'Miami, FL',
        locationKey: 'miami_fl',
        issueType: 'NAP Inconsistency',
        issueDetails: 'Phone number mismatch in 2 directories',
        impact: 'Medium',
        status: 'Needs Fix',
        detected: 'May 17, 2025',
        recommendedAction: 'Sync NAP',
        category: 'nap',
        primaryService: 'Courier Services',
        marketPriority: 'Core Market',
        activeMarket: true,
        keyMetrics: {
          gbpHealth: 'Good (85%)',
          citationConsistency: 'Good (87%)',
          averageRating: 4.7,
          totalReviews: 142,
          localPackVisibility: 'Medium (62%)',
          visibilityTrend: '4%',
          visibilityTrendUp: false,
          reviewVelocity: '3 new reviews',
          napStatus: 'Inconsistent',
          serviceArea: 'Miami-Dade County',
        },
        topIssue: {
          title: 'NAP Inconsistency',
          description:
            'Address or phone mismatch across search directories. Phone mismatch in Foursquare and TripAdvisor.',
          totalIssues: 2,
        },
        actionCenter: {
          selectedAction: 'Sync Directory NAP',
          targetLocation: 'Miami, FL',
          element: 'NAP Listings',
          decisionOrigin: 'API Checker',
          currentText:
            'Foursquare: (305) 555-0199 | TripAdvisor: (305) 555-0144',
          proposedText:
            'Update all listings to official number: (305) 555-0100',
          aiRecommendation:
            'Inconsistent NAP values hurt ranking signals. Updating Foursquare and TripAdvisor will standardize citation data.',
          aiConfidence: 97,
          riskLevel: 'Low',
          executionMode: 'Automatic API Push',
        },
      },
      {
        location: 'Tampa, FL',
        locationKey: 'tampa_fl',
        issueType: 'Service Area Gap',
        issueDetails: 'Service area not set in GBP',
        impact: 'High',
        status: 'Needs Fix',
        detected: 'May 16, 2025',
        recommendedAction: 'Update Service Area',
        category: 'service_areas',
        primaryService: 'Same-Day Courier',
        marketPriority: 'Core Market',
        activeMarket: true,
        keyMetrics: {
          gbpHealth: 'Fair (72%)',
          citationConsistency: 'Good (82%)',
          averageRating: 4.1,
          totalReviews: 64,
          localPackVisibility: 'Low (32%)',
          visibilityTrend: '6%',
          visibilityTrendUp: false,
          reviewVelocity: '2 new reviews / mo',
          napStatus: 'Consistent',
          serviceArea: 'Not Specified',
        },
        topIssue: {
          title: 'Service Area Gap',
          description:
            'GBP profile does not specify any geographic service area, limiting local query reach.',
          totalIssues: 4,
        },
        actionCenter: {
          selectedAction: 'Configure Service Areas',
          targetLocation: 'Tampa, FL',
          element: 'GBP Service Area Settings',
          decisionOrigin: 'AI Assessment',
          currentText: 'Service area: Empty (hybrid storefront).',
          proposedText:
            'Add Tampa, St. Petersburg, Clearwater, and Hillsborough County to service areas.',
          aiRecommendation:
            'Defining the service scope improves geographical relevance in local searches for delivery/courier.',
          aiConfidence: 93,
          riskLevel: 'Medium',
          executionMode: 'Human approval',
        },
      },
      {
        location: 'Aventura, FL',
        locationKey: 'aventura_fl',
        issueType: 'Duplicate Listing',
        issueDetails: 'Duplicate profile found on YellowPages',
        impact: 'Medium',
        status: 'Needs Fix',
        detected: 'May 16, 2025',
        recommendedAction: 'Remove Duplicate',
        category: 'citations',
        primaryService: 'Rush Courier',
        marketPriority: 'Expansion Market',
        activeMarket: true,
        keyMetrics: {
          gbpHealth: 'Good (89%)',
          citationConsistency: 'Fair (79%)',
          averageRating: 4.8,
          totalReviews: 32,
          localPackVisibility: 'Medium (58%)',
          visibilityTrend: '1%',
          visibilityTrendUp: true,
          reviewVelocity: '1 new review / mo',
          napStatus: 'Consistent',
          serviceArea: 'Miami-Dade County',
        },
        topIssue: {
          title: 'Duplicate Listing',
          description:
            'A secondary duplicate profile has been registered on YellowPages, splitting citation authority.',
          totalIssues: 1,
        },
        actionCenter: {
          selectedAction: 'Merge/Remove Duplicate Listing',
          targetLocation: 'Aventura, FL',
          element: 'YellowPages Citation',
          decisionOrigin: 'Scanner',
          currentText: 'Duplicate ID: YP-9921445 (Old phone: 305-555-0122).',
          proposedText:
            'Submit request to delete duplicate listing and redirect authority to main listing.',
          aiRecommendation:
            'Removing duplicates consolidates local brand signals and avoids search ranking penalties.',
          aiConfidence: 96,
          riskLevel: 'Low',
          executionMode: 'Manual request submission',
        },
      },
      {
        location: 'Boca Raton, FL',
        locationKey: 'boca_raton_fl',
        issueType: 'Unanswered Reviews',
        issueDetails: '7 reviews not answered',
        impact: 'Medium',
        status: 'Needs Attention',
        detected: 'May 15, 2025',
        recommendedAction: 'Respond to Reviews',
        category: 'reviews',
        primaryService: 'Courier Services',
        marketPriority: 'Core Market',
        activeMarket: true,
        keyMetrics: {
          gbpHealth: 'Good (84%)',
          citationConsistency: 'Good (85%)',
          averageRating: 4.4,
          totalReviews: 53,
          localPackVisibility: 'Medium (52%)',
          visibilityTrend: '3%',
          visibilityTrendUp: true,
          reviewVelocity: '2 new reviews / mo',
          napStatus: 'Consistent',
          serviceArea: 'Palm Beach County',
        },
        topIssue: {
          title: 'Unanswered Reviews',
          description:
            'There are 7 recent customer reviews that have not received an owner response.',
          totalIssues: 2,
        },
        actionCenter: {
          selectedAction: 'Reply to Reviews',
          targetLocation: 'Boca Raton, FL',
          element: 'Customer Feedback',
          decisionOrigin: 'Review Engine',
          currentText: '7 reviews with empty responses.',
          proposedText:
            'Generate personalized replies using brand tone for the 7 pending Google reviews.',
          aiRecommendation:
            'Answering feedback demonstrates customer care and boosts local signals on GBP.',
          aiConfidence: 90,
          riskLevel: 'Low',
          executionMode: 'Human approval',
        },
      },
    ];
  }

  buildSignals(): void {
    this.signals = [
      {
        signal: 'City Architecture Gap',
        to: 'URL Mapping',
        status: 'Sent',
        date: 'May 18',
      },
      {
        signal: 'Local Relevance Weak',
        to: 'On-Page',
        status: 'Sent',
        date: 'May 18',
      },
      {
        signal: 'Local Change Implemented',
        to: 'Performance',
        status: 'Sent',
        date: 'May 18',
      },
      {
        signal: 'Citation Opportunity',
        to: 'Off-Page',
        status: 'Open',
        date: 'May 17',
      },
    ];
  }

  buildRecentLocalActivity(): void {
    this.recentLocalActivity = [
      {
        text: 'Updated GBP Service Area for Tampa, FL',
        date: 'May 18, 2025 10:21 AM',
        actor: 'AI',
      },
      {
        text: 'Created Citation on Yelp for Fort Lauderdale, FL',
        date: 'May 18, 2025 9:43 AM',
        actor: 'AI',
      },
      {
        text: 'Answered 3 reviews for Miami, FL',
        date: 'May 17, 2025 4:18 PM',
        actor: 'User',
      },
    ];
  }

  // ── Tab filtering ─────────────────────────────────────────────────────────
  get filteredIssues(): any[] {
    const list = this.issuesQueue.filter((issue) => {
      const matchMarket =
        this.selectedMarketStatus === 'all' ||
        (this.selectedMarketStatus === 'active' && issue.activeMarket) ||
        (this.selectedMarketStatus === 'growth' &&
          issue.marketPriority.toLowerCase().includes('growth')) ||
        (this.selectedMarketStatus === 'expansion' &&
          issue.marketPriority.toLowerCase().includes('expansion'));

      const matchUniverse =
        this.selectedUniverse === 'all' ||
        issue.primaryService.toLowerCase().includes(this.selectedUniverse);

      const matchLocation =
        this.selectedLocation === 'all' ||
        issue.locationKey === this.selectedLocation;

      const matchService =
        this.selectedService === 'all' ||
        issue.primaryService
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '_')
          .includes(this.selectedService);

      const matchIssueType =
        !this.selectedIssueType ||
        issue.issueType
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '_')
          .includes(this.selectedIssueType);

      const matchStatus =
        !this.selectedStatus ||
        issue.status
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '_')
          .includes(this.selectedStatus);

      return (
        matchMarket &&
        matchUniverse &&
        matchLocation &&
        matchService &&
        matchIssueType &&
        matchStatus
      );
    });

    if (this.activeTab === 'all') return list;
    return list.filter((i) => i.category === this.activeTab);
  }

  setTab(key: string): void {
    this.activeTab = key;
  }

  // ── Selection ─────────────────────────────────────────────────────────────
  selectIssue(issue: any): void {
    this.selectedIssue = {
      ...issue,
      _index: this.issuesQueue.indexOf(issue),
    };
  }

  // ── Actions ───────────────────────────────────────────────────────────────
  approveAction(): void {
    this.messageService.add(
      'Action approved and queued for implementation.',
      'success',
    );
  }

  rejectAction(): void {
    this.messageService.add('Action rejected.', 'info');
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  getStatusClass(status: string): string {
    const map: Record<string, string> = {
      'Needs Attention': 'bg-warning-light text-warning',
      'Needs Fix': 'bg-danger-light text-danger',
      'Under Review': 'bg-primary-light text-primary',
      Resolved: 'bg-success-light text-success',
    };
    return map[status] || 'bg-light text-dark';
  }

  getPriorityClass(priority: string): string {
    const map: Record<string, string> = {
      High: 'bg-danger-light text-danger',
      Medium: 'bg-warning-light text-warning',
      Low: 'bg-success-light text-success',
    };
    return map[priority] || 'bg-light text-dark';
  }

  getSignalStatusClass(status: string): string {
    const map: Record<string, string> = {
      Sent: 'bg-success-light text-success',
      Open: 'bg-warning-light text-warning',
      Monitoring: 'bg-primary-light text-primary',
    };
    return map[status] || 'bg-light text-dark';
  }

  goBack(): void {
    this.router.navigateByUrl('marketing');
  }
}
